import { forbidExtraProps } from 'airbnb-prop-types';
import PropTypes from 'prop-types';
import React from 'react';
import mergeClassNames from '../utils/mergeClassNames';

const propTypes = forbidExtraProps({
  unicode: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  block: PropTypes.bool,
});

const defaultProps = {
  block: false,
};

function KeyboardShortcutRow({
  unicode,
  label,
  action,
  block,
}) {
  return (
    <li
      className={mergeClassNames(
        'KeyboardShortcutRow',
        block && 'KeyboardShortcutRow__block',
      )}
    >
      <div
        className={mergeClassNames(
          'KeyboardShortcutRow_keyContainer',
          block && 'KeyboardShortcutRow_keyContainer__block',
        )}
      >
        <span
          className={mergeClassNames('KeyboardShortcutRow_key')}
          role="img"
          aria-label={`${label},`} // add comma so screen readers will pause before reading action
        >
          {unicode}
        </span>
      </div>

      <div className={mergeClassNames('KeyboardShortcutRow_action')}>
        {action}
      </div>
    </li>
  );
}

KeyboardShortcutRow.propTypes = propTypes;
KeyboardShortcutRow.defaultProps = defaultProps;

export { KeyboardShortcutRow as PureKeyboardShortcutRow };
export default KeyboardShortcutRow;
